<template>
	<v-container fluid >
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn @click="addClick" class="ml-0" color="primary">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{$t('buttons.add')}}
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="elevation-0 background-transparent">
					<DataTable
						:excel="false"
						:headers="partnersTable.headers"
						:items="partnersTable.items"
						:total="partnersTable.total"
						@reload="reloadData"
						@excel="excelExport"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
								<td @click="editClick(props.item.id, false)">{{ props.item.username }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.first_name }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.last_name }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.email }}</td>
								<td @click="editClick(props.item.id, false)">
									<v-icon small v-if="props.item.active">fa-check</v-icon>
								</td>
								<td>
									<v-tooltip bottom>
										<v-btn @click="editClick(props.item.id, true)" icon slot="activator">
											<v-icon small>fa-external-link-alt</v-icon>
										</v-btn>
										<span>{{$t('tooltips.openInNewTab')}}</span>
									</v-tooltip>
								</td>
							</tr>
						</template>
					</DataTable>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";

export default {
	name: "Partners",
	components: {DataTable},
	data: function () {
		return {
			partnersTable: {
				headers: [
					{text: this.$t('fields.username'), value: 'username', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.firstName'), value: 'first_name', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.lastName'), value: 'last_name', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.email'), value: 'email', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.active'), value: 'active', type: 'boolean_yes', width: "100px", searchable: 'hidden'},
					{text: '', value: 'actions', type: '', sortable: false, align: "right", width: "100px", searchable: false}
				],
				items: [],
				total: 0,
				lastRequest: null
			},

		}
	},
	methods: {
		addClick() {
			this.$router.push('/partners/0')
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/partners/' + id)
			} else {
				let routeData = this.$router.resolve('/partners/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		reloadData(request) {
			this.lastRequest = request;
			let vm = this;
			this.$APICall('get', 'partners', request, (data, success) => {
				if (success) {
					vm.partnersTable.items = data.items;
					vm.partnersTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall('get', 'partners', excelRequest, (data, success) => {
				if (success) {
					vm.$APICall('post', 'excel/partners', data.items, (data, success) => {
						window.open(data.link);
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		if(this.$myStore.state.partner.partner_role_id != 1){
			this.$router.replace('/dashboard');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.partners'), href: '/#/partners', disabled: true}
		]);
	}
}
</script>

<style scoped>

</style>
